<template>
  <v-col class="pa-0" v-bind="{ ...containerProps, ...containerOptions }"/>
</template>

<script>
export default {
  name: 'HelmiSpacer',

  props: {
    containerOptions: {
      type: Object,
      default: () => ({}),
    },

    containerProps: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
